import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder mirroring the header bar + two category sections. */
export const ScorecardSkeleton: React.FC = () => (
	<div className="space-y-4" aria-hidden="true">
		<div className="flex items-center justify-between">
			<Skeleton className="h-4 w-48" />
			<Skeleton className="h-8 w-32 rounded-sm" />
		</div>
		{Array.from({ length: 2 }).map((_, sectionIndex) => (
			<div key={sectionIndex} className="rounded-sm border border-border">
				<div className="space-y-2 border-b border-border px-4 py-3">
					<Skeleton className="h-4 w-40" />
					<Skeleton className="h-1 w-full rounded-full" />
				</div>
				<div className="space-y-5 p-4">
					{Array.from({ length: 3 }).map((_, fieldIndex) => (
						<div key={fieldIndex} className="space-y-2">
							<Skeleton className="h-4 w-1/3" />
							<Skeleton className="h-8 w-2/3 rounded-sm" />
						</div>
					))}
				</div>
			</div>
		))}
	</div>
);
